import { Action } from '@ngrx/store';
import { Lookup } from '../../../business-objects/lookup/lookup.model';
import { TextControl } from '../text-control.model';
import { SearchResultModel } from './search-result.model';

export const BLUR = '[Text Control] Blur';
export const CLICK_RESULT = '[Text Control] Click Result';
export const DESTROY = '[Text Control] Destroy';
export const INIT = '[Text Control] Init';
export const INIT_SUCCESS = '[Text Control] Init Success';
export const INIT_FAIL = '[Text Control] Init Fail';
export const KEY_ENTER = '[Text Control] Key Enter';
export const KEY_ESC = '[Text Control] Key Escape';
export const KEY_DOWN = '[Text Control] Key Down';
export const KEY_UP = '[Text Control] Key Up';
export const LOAD_MORE = '[Text Control] Load More';
export const NEW_LOOKUP = '[Text Control] New Lookup';
export const RELOAD_LOOKUPS = '[Text Control] Reload Lookups';
export const RELOAD_LOOKUPS_SUCCESS = '[Text Control] Reload Lookups Success';
export const RELOAD_LOOKUPS_FAIL = '[Text Control] Reload Lookups Fail';
export const SET_SEARCH_TERM = '[Text Control] Set Input Value';
export const SET_SHOW = '[Text Control] Set Show Results';
export const SHOW_ALL = '[Text Control] Show All';
export const SHOW_ALL_DESKTOP = '[Text Control] Show All Desktop';
export const SHOW_ALL_DESKTOP_SUCCESS = '[Text Control] Show All Desktop Success';
export const SHOW_ALL_DESKTOP_FAIL = '[Text Control] Show All Desktop Fail';
export const SHOW_ALL_MOBILE = '[Text Control] Show All Mobile';
export const SHOW_ALL_MOBILE_SUCCESS = '[Text Control] Show All Mobile Success';
export const SHOW_ALL_MOBILE_FAIL = '[Text Control] Show All Mobile Fail';

export class BlurAction implements Action {
    readonly type = BLUR;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class ClickResultAction implements Action {
    readonly type = CLICK_RESULT;

    constructor(public payload: {
        instanceKey: string,
        result: SearchResultModel
    }) {
    }
}

export class DestroyAction implements Action {
    readonly type = DESTROY;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class InitAction implements Action {
    readonly type = INIT;

    constructor(public payload: {
        instanceKey: string,
        control: TextControl,
        inputValue: string
    }) {
    }
}

export class InitSuccessAction implements Action {
    readonly type = INIT_SUCCESS;

    constructor(public payload: {
        control: TextControl,
        inputValue: string,
        instanceKey: string,
        lookups: Array<Lookup>
    }) {
    }
}

export class InitFailAction implements Action {
    readonly type = INIT_FAIL;

    constructor(public payload: {
        instanceKey: string,
        error: Error
    }) {
    }
}

export class KeyEnterAction implements Action {
    readonly type = KEY_ENTER;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class KeyEscAction implements Action {
    readonly type = KEY_ESC;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class KeyDownAction implements Action {
    readonly type = KEY_DOWN;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class KeyUpAction implements Action {
    readonly type = KEY_UP;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class LoadMoreAction implements Action {
    readonly type = LOAD_MORE;

    constructor(public payload: {instanceKey: string}) {
    }
}

export class NewLookupAction implements Action {
    readonly type = NEW_LOOKUP;

    constructor(public payload: {
        accountId: string
        instanceKey: string,
        lookupTypeId: string,
        accessGroupId: string
    }) {
    }
}

export class ReloadLookupsAction implements Action {
    readonly type = RELOAD_LOOKUPS;

    constructor(public payload: {
        instanceKey: string,
        lookupType: string
    }) {
    }
}

export class ReloadLookupsSuccessAction implements Action {
    readonly type = RELOAD_LOOKUPS_SUCCESS;

    constructor(public payload: {
        instanceKey?: string,
        lookupTypeId: string,
        lookups: Array<Lookup>
    }) {
    }
}

export class ReloadLookupsFailAction implements Action {
    readonly type = RELOAD_LOOKUPS_FAIL;

    constructor(public payload: {
        instanceKey: string,
        error: Error
    }) {
    }
}

export class SetSearchTermAction implements Action {
    readonly type = SET_SEARCH_TERM;

    constructor(public payload: {
        instanceKey: string,
        searchTerm: string
    }) {
    }
}

export class SetShowResultsAction implements Action {
    readonly type = SET_SHOW;

    constructor(public payload: {
        instanceKey: string,
        showResults: boolean
    }) {
    }
}

export class ShowAllAction implements Action {
    readonly type = SHOW_ALL;

    constructor(public payload: {
        instanceKey: string,
        lookupTypeId: string
    }) {
    }
}

export class ShowAllDesktopAction implements Action {
    readonly type = SHOW_ALL_DESKTOP;

    constructor(public payload: {
        instanceKey: string,
        lookupTypeId: string
    }) {
    }
}

export class ShowAllDesktopSuccessAction implements Action {
    readonly type = SHOW_ALL_DESKTOP_SUCCESS;

    constructor(public payload: {
        instanceKey: string
    }) {
    }
}

export class ShowAllDesktopFailAction implements Action {
    readonly type = SHOW_ALL_DESKTOP_FAIL;

    constructor(public payload: {
        instanceKey: string,
        error: Error
    }) {
    }
}

export class ShowAllMobileAction implements Action {
    readonly type = SHOW_ALL_MOBILE;

    constructor(public payload: {
        instanceKey: string,
        lookupTypeId: string
    }) {
    }
}

export class ShowAllMobileSuccessAction implements Action {
    readonly type = SHOW_ALL_MOBILE_SUCCESS;

    constructor(public payload: {
        instanceKey: string,
        lookupId: string
    }) {
    }
}

export class ShowAllMobileFailAction implements Action {
    readonly type = SHOW_ALL_MOBILE_FAIL;

    constructor(public payload: {
        instanceKey: string,
        error: Error
    }) {
    }
}

export type Actions
    = BlurAction
    | ClickResultAction
    | DestroyAction
    | InitAction
    | InitSuccessAction
    | InitFailAction
    | KeyEnterAction
    | KeyEscAction
    | KeyDownAction
    | KeyUpAction
    | LoadMoreAction
    | NewLookupAction
    | ReloadLookupsAction
    | ReloadLookupsSuccessAction
    | ReloadLookupsFailAction
    | SetSearchTermAction
    | SetShowResultsAction
    | ShowAllAction
    | ShowAllDesktopAction
    | ShowAllDesktopSuccessAction
    | ShowAllDesktopFailAction
    | ShowAllMobileAction
    | ShowAllMobileSuccessAction
    | ShowAllMobileFailAction
    ;



// WEBPACK FOOTER //
// ./src/vas/controls/text/form/text-control.actions.ts